import PrincipleItem from "./PrincipleItem";
import SectionKicker from "./SectionKicker";
import useScrollFade from "../hooks/useScrollFade";
import { culture } from "../data/content";

export default function Culture() {
  const [ref] = useScrollFade();

  return (
    <section id="culture" className="relative overflow-hidden bg-site-surface px-6 py-24 md:py-32">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 top-0 h-96 w-96 -translate-x-1/2 -translate-y-1/3 rounded-full bg-omnyx-cyan/15 blur-3xl"
      />

      <div className="relative mx-auto max-w-site text-center">
        <SectionKicker index="03" label="Culture" />
        <h2 className="font-heading text-4xl font-extrabold tracking-tightest text-site-ink md:text-5xl">
          {culture.title}
        </h2>

        <div ref={ref} className="mt-14 grid gap-10 text-left sm:grid-cols-2 lg:grid-cols-4">
          {culture.principles.map((item) => (
            <PrincipleItem
              key={item.title}
              title={item.title}
              description={item.description}
              accent={item.accent}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

